<template>
  <div class="map-button-wrapper">
    <button type="button" class="button btn-list" v-if="this.$route.name == 'map'" @click="navigateBack">{{ $t('list') }}</button>
    <div class="button btn-list active" v-if="this.$route.name != 'map'">{{ $t('list') }}</div>
    <div class="button btn-map active" v-if="this.$route.name == 'map'"> {{ $t('buttonActions.map') }}</div>
    <router-link class="button btn-map" v-if="this.$route.name != 'map'" :to="{ name: 'map', params: { 'entity': this.selectedEntities } }">
          <span class="map-label">
							{{ $t('buttonActions.map') }}
						</span>
    </router-link>
  </div>

</template>

<script>
	export default {
		name: 'MapButton',
		props: {
			from: {
				type: String,
				default () {
					return ""
				}
			},
		},
		computed: {

		},
		methods: {
			navigateBack () {
        this.$router.go(-1)
			}
		}
	}
</script>

<style lang="scss" scoped>

.map-button-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  text-transform: uppercase;

  .button {
    color: $dark-gray;
    background-color: $light-gray;
    border-color: $medium-gray;
    font-weight: bold;

    &.active,
    &:hover {
      color: white;
      background-color: $dark-gray;
    }
  }

  .btn-map {
    border-radius: 0 50px 50px 0;
    padding: 15px 32px 15px 28px;
  }

  .btn-list {
    border-radius: 50px 0 0 50px;
    padding: 15px 28px 15px 32px;
  }

}
</style>
